import { ACCOUNT_TYPE } from '_constants';

import { ContentSettingV2, Exercise } from '../../types';
import { UseGetAllPatientExercisesByIdProps } from '../types';
import usePermittedQuery from '../usePermittedQuery';

export const GET_ALL_PATIENT_EXERCISES_BY_ID_KEY = 'get-all-patient-exercises-by-id';

export const useGetAllPatientExercisesByID = ({
  patientId,
  page = 0,
  size = 1000,
}: UseGetAllPatientExercisesByIdProps) => {
  return usePermittedQuery<ContentSettingV2<Exercise>[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () =>
      `/exercise/get-all-patient-exercise-settings/${patientId}?page=${page}&size=${size}`,
    {
      headers: {
        Accept: 'application/vnd.ysh.api.v2+json',
      },
    },
    [GET_ALL_PATIENT_EXERCISES_BY_ID_KEY, patientId],
    {
      enabled: typeof patientId === 'number' && patientId > 0,
      refetchOnWindowFocus: false,
    },
  );
};
